// extracted by mini-css-extract-plugin
module.exports = {"page":"page_page__ZMtnD","content":"page_content__RpVyv"};